/**
 * Newsletter Module
 * 
 * Handles the newsletter signup form in the site footer.
 *
 * TODO
    Update to work with craft.
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.newsletter = function () {

        var initModule = function () {

            // Handle newsletter key press - not needed
            $('.js-newsletter-form').find('.email').keypress(function(event){
                // enter key is pressed
                //if (event.which == 13) { }
            });

            // Handle newsletter signup form submission
            $('.js-newsletter-form').on('submit', function(event) {
                event.preventDefault();
                submitForm(event);
            });

        }

        var submitForm = function(event) {

            var $container = $('.js-newsletter-container');
            var $form = $('.js-newsletter-form');
            var $response = $('.js-newsletter-response');
            
            $.post({
                url: '/',
                dataType: 'json',
                data: $form.serialize(),
                success: function(response) {
                    
                    // lock div height
                    $container.css('height', $container.height());

                    // display response
                    $response.find('p').html('Thank you.');
                    $form.fadeOut(200, clearForm).delay(2600).fadeIn(200);
                    $response.delay(200).fadeIn(200).delay(2000).fadeOut(200);

                }
            });
        }

        var clearForm = function() {
            $('.js-newsletter-form').find('.email').val('');
        }

        return {
            initModule: initModule
        };
    }();

    pz.newsletter.initModule();
});